<template>
  <PageContainer>
    <div class="credito-content">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="mb-0">Tipos de Créditos</h3>
        <Button text="Novo Crédito" color="primary" @handle:click="abrirModalNovoCredito" />
      </div>
      <LoadingSpinner v-if="carregando" />
      <Table v-else :headers="headersTabelaCreditos" :selectable="false">
        <tr v-for="credito in tiposCreditos" :key="credito.id">
          <td>{{ credito.nome }}</td>
          <td>{{ formatarMoeda(credito.valor) }}</td>
          <td>
            <Button text="Editar" color="secondary" size="small" @handle:click="abrirModalEditarCredito(credito)" />
          </td>
        </tr>
        <tr v-if="tiposCreditos.length === 0">
          <td colspan="3" class="text-center text-muted">Nenhum tipo de crédito cadastrado.</td>
        </tr>
      </Table>

      <!-- Modal de Novo/Editar Crédito -->
      <Modal v-if="modalAberto" @close="fecharModal">
        <template #header>
          <h5 class="mb-0">{{ editandoCredito ? 'Editar Crédito' : 'Novo Crédito' }}</h5>
        </template>
        <template #body>
          <form @submit.prevent="salvarCredito">
            <Input legend="Nome do Crédito" v-model="formCredito.nome" :disabled="carregando" required />
            <Input legend="Valor (R$)" type="number" min="0.01" step="0.01" v-model.number="formCredito.valor" :disabled="carregando" required />
          </form>
        </template>
        <template #footer>
          <Button text="Cancelar" color="secondary" :fill="false" @handle:click="fecharModal" :disabled="carregando" />
          <Button text="Salvar" color="primary" @handle:click="salvarCredito" :disabled="carregando || !formCredito.nome || !formCredito.valor" />
        </template>
      </Modal>
    </div>
  </PageContainer>
</template>

<script>

import PageContainer from '@/components/core/PageContainer.vue'
import Button from '@/components/core/Button.vue'
import Table from '@/components/core/Table.vue'
import Input from '@/components/core/Input.vue'
import Modal from '@/components/core/Modal.vue'
import LoadingSpinner from '@/components/core/LoadingSpinner.vue'
import urlApi from '@/router/urlApiV2';

export default {
  name: 'CreditoIndex',
  components: {
    PageContainer,
    Input,
    Button,
    Table,
    LoadingSpinner,
  },
  data () {
    return {
      tiposCreditos: [],
      carregando: false,
      modalAberto: false,
      editandoCredito: false,
      formCredito: {
        id: null,
        nome: '',
        valor: null,
      },
      headersTabelaCreditos: ['Nome', 'Valor', 'Ações'],
    }
  },
  mounted () {
    this.carregarCreditos()
  },
  methods: {
    async carregarCreditos () {
      this.carregando = true
      try {
        await this.$http.get(`${urlApi}/creditos/`)
          .then((response) => {
            this.tiposCreditos = response.body.data.map(credito => ({
              id: credito.id,
              nome: credito.descricao,
              valor: credito.preco,
            }))
          })
          .catch((err) => {
            this.launchToast('fa-exclamation', err.body.message || 'Erro ao carregar os créditos.')
          })
      } catch (e) {
        this.launchToast('fa-exclamation', 'Erro ao carregar os créditos.')
      } finally {
        this.carregando = false
      }
    },
    launchToast(icon, msg) {
      this.$toasted.show(msg, {
        icon: icon,
        position: "top-right",
        duration: 5000,
        fullWidth: false
      });
    },
    abrirModalNovoCredito () {
      this.editandoCredito = false
      this.formCredito = { id: null, nome: '', valor: null }
      this.modalAberto = true
    },
    abrirModalEditarCredito (credito) {
      this.editandoCredito = true
      this.formCredito = { ...credito }
      this.modalAberto = true
    },
    fecharModal () {
      this.modalAberto = false
    },
    async salvarCredito () {
      this.carregando = true
      try {
        if (this.editandoCredito) {
          // Em produção, PUT na API
          const idx = this.tiposCreditos.findIndex(c => c.id === this.formCredito.id)
          if (idx !== -1) this.tiposCreditos[idx] = { ...this.formCredito }
        } else {
          // Em produção, POST na API
          const novo = { ...this.formCredito, id: Date.now() }
          this.tiposCreditos.push(novo)
        }
        this.fecharModal()
      } catch (e) {
        // Exibir erro
      } finally {
        this.carregando = false
      }
    },
    formatarMoeda (valor) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(valor)
    },
  },
}
</script>

<style lang="scss" scoped>
.credito-content {
  width: 100%;
  margin: 0 auto;
  padding: 2rem 1rem 2.5rem 1rem;
  background-color:#fff
}

.filtros-section {
  background: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  padding: 2rem 2rem 1.5rem 2rem;
  margin-bottom: 2rem;
  border: none;
}
.filtros-header {
  gap: 2rem;
  flex-wrap: wrap;
}
.creditos-info {
  min-width: 220px;
  margin-bottom: 0.5rem;
}
.creditos-label {
  font-size: 1.1rem;
  color: #222;
  font-weight: 500;
  margin-bottom: 0.2rem;
}
.creditos-valor {
  font-size: 2.1rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 0.2rem;
}
.creditos-status {
  font-size: 1rem;
  color: #00b69b;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}
.filtros-actions {
  display: flex;
  gap: 0.5rem;
}
.g-3 > [class^='col-'] {
  margin-bottom: 1rem;
}
.transacoes-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  padding: 2rem 2rem 1.5rem 2rem;
  border: none;
}
.table-responsive {
  margin-top: 1rem;
}
.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  color: #fff;
  font-weight: 600;
  border-radius: 6px;
  padding: 0.5rem 1.2rem;
}
.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
  color: #fff;
  font-weight: 600;
  border-radius: 6px;
  padding: 0.5rem 1.2rem;
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.text-muted {
  color: #6c757d;
}
.mb-4 {
  margin-bottom: 1.5rem;
}
.g-3 {
  align-items: center;
  display: flex;
  gap: 1.5rem;
}
.g-3 > [class^='col-'] {
  margin-bottom: 1rem;
  flex: 1 1 0;
}
.ml-2 {
  margin-left: 0.5rem;
}
.card {
  border: 1px solid #dee2e6;
  border-radius: 12px;
}
</style>
